export default {
  LandingPage: {
    intro_sub:
      'S našimi eko obalmi chránite životné prostredie.',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Pridajte sa k nám a znížte množstvo produkovaného odpadu s ekologickými obalmi, ktoré pretvárame na užitočné veci.',
    sequence1_2:
      'Urobte prvý krok a prescrolujte nižšie.',
    sequence2_1: 'Predstavujeme Samsung Upcycle-Packaging',
    sequence2_2:
      'Krabica výrobok špeciálne navrhnutá k recyklácii s minimálnym dopadom na životné prostredie. Vytvorte si z použitého obalu rôzne predmety pre vašu domácnosť.',
    sequence3_1: 'Sledujte vytlačené body na balení',
    sequence3_2:
      'Vyrežte vyznačené body na balení a vytvorte tak jedinečný predmet.',
    sequence4_1: 'Vyberte predmet, ktorý chcete vytvoriť',
    sequence4_2:
      'SPrescrolujte nižšie a vyberte si model výrobok, ktorý vlastníte. Následne zistite, aký predmet môžete z balenia vytvoriť. Uspokojte svoju zvedavosť po nových a unikátnych veciach.',
    selectBox: 'Vyberte výrobok',
    moreActivity:
      "Pre viac informácií o trvalo udržateľných aktivitách spoločnosti Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitory', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Soundbary série Q', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/sk/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/sk/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/sk/sustainability/overview/',
    footer: `Copyright© 1995-2021 Samsung. Všetky práva vyhradené.`,
  },
  ProductPage: {
    selectDesign: 'Vyberte dizajn',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV stolík ',
    StorageBox: 'Krabica na veci',
    MagazineRack: 'Stojan na časopisy',
    CatHouse: 'Domček pre mačky',
    CatTunnel: 'Tunel pre mačky',
    BookShelf: 'Polička na knihy',
    DeskShelf: 'Polička na stôl',
    BlackRhino: 'Ohrozené zvieratá - čierny nosorožec', //update
    PolarBear: 'Ohrozené zvieratá - polárny medveď', //update
    SeaTurtle: 'Ohrozené zvieratá - morská korytnačka', //update
    TheRider: 'Hojdací kôň', //update
    Kibe: 'Schody', //update
    Tessellate: 'Konferenčný stolík', //update
    Twist: 'Krabica - Twist', //update
    AlexCouchArmTable: 'Organizér na pohovku', //update
    BlastOffClubHouse: 'Domček', //update
    KinokoTable: 'Stolík Kinoko', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Stolík Gio', //update
    PostCardPlanter: 'Stojan na pohľadnice', //update
    SneakerRack: 'Botník', //update
    TheSoban: 'Stolička Soban', //update
    ToolBox: 'Box na náradie', //update
    DeskStationary: 'Papierníctvo',
    CoinBank: 'Pokladnička',
    MobileScanner:'Stojan na telefón',
    TabletScanner:'Stojan na tablet',
    PetStairs:'Schody pre domácich miláčikov',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minúty',
    all:'ALL',
    in: 'v',
    inOnly: 'iba v',
    allBoxSize: 'Všetky rozmery krabíc',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'inštrukcie',
    prepare: 'Pripravte si krabicu',
    LetsDesign: "Poďme na to",
    drawParts: 'Nakreslite jednotlivé časti na krabicu',
    note1: 'Rozmery krabíc sa môžu líšiť v závislosti od veľkosti a krajiny.',
    note2: 'Uistite sa, že celá kresba sa zmestí na krabicu',
    numberSpace: 'číslo = prázdne miesta medzi bodkami',
    diagonal: 'uhlopriečka',
    LEFT: 'ĽAVÁ ČASŤ',
    RIGHT: 'PRAVÁ ČASŤ',
    TOP: 'VRCHNÁ ČASŤ',
    TOP1: 'VRCHNÁ ČASŤ 1',
    TOP2: 'VRCHNÁ ČASŤ 2',
    BACK: 'ZADNÁ ČASŤ',
    MIDDLE: 'STREDNÁ ČASŤ',
    MIDDLE2: 'STREDNÁ ČASŤ 2',
    BOTTOM: 'SPODNÁ ČASŤ',
    FRONT: 'PREDNÁ ČASŤ',
    SIDE: 'BOČNÁ ČASŤ',
    secondSIDE: 'DRUHÁ STRANA',
    secondSIDE1: 'DRUHÁ STRANA 1',
    secondSIDE2: 'DRUHÁ STRANA 2',
    LEG: 'NOHA', //update
    JOINT: 'KĹB', //update
    FACE: 'TVÁR', //update
    DRAWERBOTTOM: 'DNO ZÁSUVKY', //update
    DRAWERSIDE: 'STRANA ZÁSUVKY', //update
    NOSE: 'NOS', //update
    HANDLE: 'DRŽIAK', //update
    BOTTOMSIDE: 'SPODNÁ ČASŤ', //update
    TOPSIDE: 'VRCHNÁ ČASŤ', //update
    WING: 'KRÍDLO', //update
    cutAndAssemble: "Vyrežte a zložte",
    beCareful: 'uďte opatrný a neporaňte sa pri manipulácii s nástrojom na strihanie či orezávanie',
    cutOutParts: 'Vyrežte vyznačené časti',
    assemble: 'Zložte',
    Assemblyguide: 'Manuál na zloženie', //update
    fold: 'Vzor skladania',
    foldGuide: 'Pri ohýbaní lepenky použite okraj nábytku',
    foldGuideDezeen:
      'Niekoľkokrát stlačte prerušovanú čiaru na lepenke pomocou ryhovacích nástrojov, aby sa lepenka dokázala lepšie ohnúť.', //update
    glue: 'Na povrch rovnomerne naneste lepidlo alebo pásku', //update
    cable: 'Na prepojenie použite sťahovacie pásky alebo šnúrky', //update
    done: 'Hotovo!',
    goBack: 'Choďte späť do hlavného menu',
  },
  CautionPage: {
    CAUTION: 'UPOZORNENIE',
    needItem: 'Budete potrebovať tieto predmety',
    children: 'Deti by mali byť v prítomnosti rodičov',
    mat:
      'Prosím, položte na zem ochranné prostriedky, aby ste zabránili poškodeniu podlahy',
    doNotPutHeavyThing:
      'Nestúpajte ani nesadajte na tieto predmety, taktiež ich nepreťažujte ťažkými ostatnými predmetmi',
    doNotThrow:
      'Nehádžte ani nekopte s predmetmi',
    stayAwayFlame: 'Chráňte pred ohňom',
    stayAwayWater: 'Nie je vhodné umiestňovať v blízkosti vody a do vlhkého prostredia',
    mayDamaged: '* TV krabice môžu byť poškodené v dôsledku prepravy.',
    companyDoestResponsible:
      '* Spoločnosť nenesie zodpovednosť za zranenia a úrazy spojené s touto činnosťou.',
    cannotBeReturned:
      '* Produkt s poškodenou krabicou nemôže byť vrátený pre problémy spojené s jej kvalitou.',
    understand: 'Áno, rozumiem',
  },
  PrivacyPolicy: {
    title: 'Zásady ochrany osobných údajov',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'V porovnaní s našimi predchádzajúcimi obalmi, využívame menej papiera a atramentu. Záleží nám na životnom prostredí a preto inovujeme balenia s ohľadom na našu planétu.',
      text2:'',
      text2_special:
        '(* Vyššie uvedené neplatí pre všetky modely vrátane Lifestyle televízorov)',
      text3: 'Zvoľte tlačidlo nižšie a dozviete sa viac',
    },
    greenIn: {
      title: 'Sme Eko v TV obaloch',
      subtitle1: 'Vyhľadať informácie o produkte',
      subtitle2: 'Upcycling Eko balenia',
      desc: 'Pre viac informácií vyhľadajte model televízora',
      descM: '* Urobte fotografiu televízora a jeho modelového čísla',
      guide: 'názov modelu',
      button: 'Odfotiť',
      button2: 'Prejsť na výrobu predmetov',
      product_info: 'Informácie o produkte',
    },
    search: {
      guide: 'Vyhľadať..',
      noResult: 'Žiadne výsledky',
      more: 'VIAC',
      search: 'Vyhľadať',
      retake: 'Opakovať',
      result: 'Výsledky',
    },
    photo: {
      guide1: 'Napíšte model televízora do určeného poľa',
      guide2: '(napr. Q800A, UT7000, RU7100 a pod.)',
    },
  },
  searchCountrySelect: 'Zvoľte krajinu'
};
